module.exports = __webpack_public_path__ + "img/mail-computer.0ade2a71.png";